export default function useAuthTokens() {
  let accessToken: null | string = null

  async function getAccessToken() {
    if (!accessToken) {
      const response = await fetch('/api/auth/access-token/', {
        method: 'GET',
      })
      const data = await response.json()

      if (data.access_token) {
        accessToken = data.access_token
      } else {
        accessToken = null
      }
    }

    return accessToken
  }

  return {
    getAccessToken,
  }
}
